// src/pages/usa/colorado/Fruita.js
import "../../../App.css";
import Header from "../../../components/Header";
import Footer from "../../../components/Footer";

import BackOnly from "../../../components/BackOnly";
import ContactPopup from "../../../components/ContactPopup";
import React, { useState, useEffect } from "react";

import { useNavigate } from "react-router-dom";   // ⭐ REQUIRED

import AffiliateBooking from "../../../components/affiliate/AffiliateBooking";
import AffiliateExpedia from "../../../components/affiliate/AffiliateExpedia";
import AffiliateTrip from "../../../components/affiliate/AffiliateTrip";

// ⭐ STRICT COMMAND: Fruita ALWAYS goes back to Colorado map
export const backRoute = "/map/colorado";

export default function Fruita() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  // ⭐ Send strict back command to BackOnly (NO LOOPS)
  useEffect(() => {
    if (!window.__fruitaBackRouteSet) {
      window.__fruitaBackRouteSet = true;
      navigate(".", { replace: true, state: { backRoute } });
    }
  }, [navigate]);

  return (

    <>
      <Header />

      <div className="visited-back-wrapper">
        <BackOnly />
      </div>


      <div className="page-container" style={{ padding: "12px" }}>
        <h1>Fruita, Colorado</h1>

        <section className="travel-review">
          {/* LEFT COLUMN — TEXT */}
          <div className="travel-text">
            <h2>Discover Fruita, Colorado</h2>

           <p>
  Fruita sits on the western edge of Colorado, just outside Grand Junction, and is known
  for its red‑rock landscapes, outdoor adventures, and small‑town charm. It’s a gateway
  to the Colorado National Monument, the Kokopelli Trail, and some of the best mountain
  biking in the state. The town has a relaxed vibe, friendly locals, and a strong
  connection to its agricultural roots.
</p>

<p>
  Fruita has deep roots in western Colorado history. It began as a small agricultural
  community along the Colorado River, known for orchards, farming, and the early
  homesteaders who settled the valley. Over time, the town grew into a gathering place
  for travelers, ranchers, and outdoor explorers heading toward the canyons and mesas
  nearby. Today, Fruita blends that historic small‑town feel with a strong outdoor
  culture, local festivals, and a welcoming community that takes pride in its western
  heritage.
</p>



            <h3>🚗 Getting There</h3>

<p>
  Fruita is easy to reach from several parts of Colorado. The closest airport is
  Grand Junction Regional Airport (GJT), only about 20 minutes away, making it the
  most convenient option if you're flying in. GJT has direct flights from Denver,
  Phoenix, Salt Lake City, Dallas, and other major hubs.
</p>
<p>
  You can also fly into Denver International Airport (DEN) and drive west to Fruita,
  or connect to a short flight into Grand Junction. Either way, the western slope
  welcomes you with open views, red‑rock cliffs, and easy access to outdoor
  adventures as soon as you arrive.
</p>
<p>
  If you're coming from Denver, the drive takes about 4 hours along I‑70. It’s a
  straightforward route that takes you through mountain passes, canyons, and wide‑open
  western landscapes. Many travelers choose this drive for the scenery alone.
</p>



            {/* 🌟 MY PERSONAL OBSERVATION */}
            <h3>🌟 My Personal Observation</h3>

            <ul>
   <li>
  <div className="place-block">
   <strong>Colorado National Monument:</strong> Colorado National Monument is one of the most impressive 
   landscapes on the western slope, with massive red‑rock canyons, towering sandstone formations, and dramatic
    overlooks. Rim Rock Drive winds along the edge of the cliffs, offering nonstop views of the valleys and 
    rock spires below. Whether you’re hiking, driving, or stopping at viewpoints, it’s one of the must‑see 
    places near Fruita.
<br />
    <a
      href="https://www.google.com/maps?q=39.120225294010176, -108.73192541680508"
      target="_blank"
      rel="noopener noreferrer"
    >
      📍 National Monument
    </a>
  </div>
</li>
   </ul>

            {/* 🏔️ HIDDEN GEMS */}
<h3>🏔️ Hidden Gems in Fruita</h3>

<ul>

  <li>
    <div className="place-block">
      <strong>Downtown Fruita:</strong> A small but lively area with local cafés, murals,
      shops, and a relaxed western‑slope vibe. Great spot to walk around after exploring
      the trails.
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>Kokopelli Trail Access Points:</strong> Even if you’re not riding the full
      trail to Moab, the Fruita sections offer incredible desert views, short hikes, and
      easy pull‑offs to explore the mesas and canyons.
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>Rattlesnake Arches Viewpoint:</strong> One of the largest natural arch
      collections outside Utah. The drive and hike are rugged, but the scenery feels
      completely untouched and remote.
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>James M. Robb Colorado River State Park:</strong> A peaceful riverside area
      perfect for kayaking, fishing, walking trails, and enjoying sunset views along the
      Colorado River.
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>Dinosaur Journey Museum:</strong> A family‑friendly museum with fossils,
      interactive exhibits, and real paleontology digs from the region. A fun stop for
      kids and anyone interested in the area’s prehistoric history.
    </div>
  </li>

</ul>


            {/* 🛏️ PLACES TO STAY */}
          <h3>🛏️ Places to Stay in Fruita</h3>

<p>
  Fruita has several solid lodging options, especially for travelers visiting the trails,
  the state park, or the western slope. These well‑rated choices appear on Booking.com
  and Expedia unless noted otherwise. Always double‑check for the latest reviews and
  availability.
</p>

<ul>

  <li>
    <div className="place-block">
      <strong>Comfort Inn & Suites Fruita:</strong>
      One of the most popular stays in town, with clean rooms, a pool, and a great
      location near the Colorado River State Park.
      <em> (Listed on Booking & Expedia)</em>
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>La Quinta Inn & Suites by Wyndham Fruita:</strong>
      A reliable option with comfortable rooms, indoor pool, and easy access to I‑70.
      Great for families and road‑trippers.
      <em> (Listed on Booking & Expedia)</em>
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>Balanced Rock Inn:</strong>
      A simple, budget‑friendly motel with clean rooms and a convenient location close
      to downtown Fruita and local restaurants.
      <em> (Listed on Booking)</em>
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>Red Cliff Lodge – Fruita Area Rentals:</strong>
      Private cabins and small rentals with kitchenettes and quiet surroundings. Great
      for longer stays or travelers wanting more space.
      <em> (Some units not listed on Booking/Expedia)</em>
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>Hacienda Colorado Guesthouse:</strong>
      A cozy, southwestern‑style guesthouse offering a peaceful stay just outside town.
      Perfect for travelers looking for something more personal and quiet.
      <em> (Direct booking only)</em>
    </div>
  </li>

</ul>


<h3>If you are looking for a place to stay, you can check prices, date and time here.</h3>
            <div className="affiliate-block">
              <AffiliateExpedia />
              <AffiliateBooking />
              <AffiliateTrip />
            </div>

            {/* 🎥 VIDEOS */}
            <h3>🎥 My Travel Videos</h3>

            <p>Here are some videos I took from Grottos Ice Cave and Ashcroft Ghost Town.</p>

        <p>
  <a
    href="https://youtu.be/CsMn2u8Fubs?si=D2QPZ43mj0etsQFx"
    target="_blank"
    rel="noopener noreferrer"
  >
    National Monument
  </a>
</p>

</div>

{/* RIGHT COLUMN — IMAGES */}
<div className="travel-image-column">
  <a
    href="https://youtu.be/CsMn2u8Fubs?si=D2QPZ43mj0etsQFx"
    target="_blank"
    rel="noopener noreferrer"
    className="youtube-image-card"
  >
    <img
      src="/images/usa/colorado/fruita/nm1.jpg"
      alt="colorado national monument video"
    />
  </a>

 
 <img src="/images/usa/colorado/fruita/nm2.jpg" alt="Colorado National Monument" />
  <img src="/images/usa/colorado/fruita/nm3.jpg" alt="Colorado National Monument" />
  <img src="/images/usa/colorado/fruita/nm4.jpg" alt="Colorado National Monument" />
  <img src="/images/usa/colorado/fruita/nm5.jpg" alt="Colorado National Monument" />
  <img src="/images/usa/colorado/fruita/nm6.jpg" alt="Colorado National Monument" />
  <img src="/images/usa/colorado/fruita/nm7.jpg" alt="Colorado National Monument" />
  <img src="/images/usa/colorado/fruita/nm8.jpg" alt="Colorado National Monument" />
  <img src="/images/usa/colorado/fruita/nm9.jpg" alt="Colorado National Monument" />
  <img src="/images/usa/colorado/fruita/nm10.jpg" alt="Colorado National Monument" />
  <img src="/images/usa/colorado/fruita/nm11.jpg" alt="Colorado National Monument" />
  <img src="/images/usa/colorado/fruita/nm12.jpg" alt="Colorado National Monument" />
  <img src="/images/usa/colorado/fruita/nm13.jpg" alt="Colorado National Monument" />
 

  
</div>
</section>
</div>

{/* Centered email button */}
<div className="email-wrapper">
  <button className="email-link" onClick={() => setOpen(true)}>
    contact@thefindingspot.com
  </button>
</div>

{/* Popup */}
<ContactPopup isOpen={open} onClose={() => setOpen(false)} />

<Footer />
</>
);
}
